import React from 'react';
import framework from 'utils/framework';
import { Box } from 'components/ui';
import AutoReplenishmentMain from 'components/RichProfile/MyAccount/AutoReplenishment/AutoReplenishmentMain';

const { wrapFunctionalComponent } = framework;

/**
 * Auto Replenishment page component.
 * Renders the main container for the Auto Replenishment feature in My Account.
 *
 * @returns {React.Element} The Auto Replenishment page wrapped in a Box layout
 */
const AutoReplenishment = () => (
    <Box>
        <AutoReplenishmentMain />
    </Box>
);

export default wrapFunctionalComponent(AutoReplenishment, 'AutoReplenishment');
